import { Check, Languages } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaDropdownMenu } from "@/shared/components/overlays/ColocaDropdownMenu";

interface LangDropdownProps {
  items: { label: string; value: string }[];
  onChange?: (value: string) => void;
  defaultSelected?: string;
  /** @deprecated kept for backwards compatibility — DS tokens adapt to the active theme automatically. */
  isWhite?: boolean;
}

export const LangDropdown = ({ items, onChange, defaultSelected }: LangDropdownProps) => {
  const selected = defaultSelected ?? items[0].value;
  const selectedItem = items.find((i) => i.value === selected) ?? items[0];

  return (
    <ColocaDropdownMenu
      align="end"
      trigger={
        <ColocaButton variant="default" icon={Languages}>
          {selectedItem.label}
        </ColocaButton>
      }
      items={items.map((item) => ({
        label: item.label,
        icon: item.value === selected ? Check : undefined,
        onClick: () => onChange?.(item.value),
      }))}
    />
  );
};
